'use client';

import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import {
  Button,
} from '@components/common';
import { useCompanyJobActions } from '@components/templates/my-jobs/hooks/useCompanyJobActions';
import { SearchpackConfirmationDialog } from '@components/templates/my-jobs/SearchpackConfirmationDialog';

interface MyJobCardActionsProps {
  job: Partial<ApiSchema<'MyJobCard'>>;
  jobId?: number;
  revalidate?: (jobSlug: string, oldStatus: string, newStatus: string) => void;
  onSuccessActivation?: () => void;
}


export const SearchpackButton = (props: MyJobCardActionsProps) => {
  const {
    job, revalidate, onSuccessActivation, jobId = 0,
  } = props;
  const { t } = useTranslation('common');

  const revalidateJob = useCallback((newStatus: string) => {
    revalidate?.(job.slug!, job.state!, newStatus);
  }, [revalidate, job]);

  const {
    isSearchpackConfirmationOpen,
    openSearchpackConfirmation,
    handleSearchpackConfirm,
    handleSearchpackCancel,
    isActivatingSearchpack,
  } = useCompanyJobActions({
    jobSlug: job.slug!,
    jobId,
    currentJobState: job.state,
    onSuccesSearchpackActivation: () => {
      revalidateJob?.(job.state ?? 'active');
      onSuccessActivation?.();
    },
  });

  return (
    <>
      <div className="flex items-center gap-2">
        <Button
          styling="none"
          size="sm"
          className="flex gap-2 text-left text-sm text-info hover:underline"
          aria-label={t('my-jobs.card.actions.searchpack')}
          onClick={() => { void openSearchpackConfirmation(); }}
          spinnerClass="size-6"
        >
          {t('my-jobs.card.actions.searchpack')}
        </Button>
      </div>

      <SearchpackConfirmationDialog
        open={isSearchpackConfirmationOpen}
        onConfirm={handleSearchpackConfirm}
        onCancel={handleSearchpackCancel}
        isConfirmLoading={isActivatingSearchpack}

      />
    </>
  );
};
